export var MapMode;
(function (MapMode) {
  MapMode["generate"] = "generated";
  MapMode["inherit"] = "inherit";
})(MapMode || (MapMode = {}));
export var CompositeMode;
(function (CompositeMode) {
  CompositeMode["normal"] = "normal";
  CompositeMode["multiply"] = "multiply";
  CompositeMode["overlay"] = "overlay";
  CompositeMode["mask"] = "destination-in";
  CompositeMode["sourceIn"] = "source-in";
})(CompositeMode || (CompositeMode = {}));